import { render } from "./OrderPage.vue?vue&type=template&id=69930742"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"

import "./OrderPage.vue?vue&type=style&index=0&id=69930742&lang=css"
script.render = render

export default script